import React from 'react';

interface Props {
  date: Date;
}

const DateComponent = ({ date }: Props) => {
  const day = date.getDate();
  const dayStr = day < 10 ? '0' + day : day;
  const month = date.getMonth() + 1;
  const monthStr = month < 10 ? '0' + month : month;
  const year = date.getFullYear();

  const hour = date.getHours();
  const hourStr = hour < 10 ? '0' + hour : hour;
  const minute = date.getMinutes();
  const minuteStr = minute < 10 ? '0' + minute : minute;

  return <span>{`${dayStr}.${monthStr}.${year} ${hourStr}:${minuteStr}`}</span>;
};

export default DateComponent;
